import { render, staticRenderFns } from "./snackbar.vue?vue&type=template&id=79b3fc86&scoped=true&"
import script from "./snackbar.vue?vue&type=script&lang=js&"
export * from "./snackbar.vue?vue&type=script&lang=js&"
import style0 from "./snackbar.vue?vue&type=style&index=0&id=79b3fc86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b3fc86",
  null
  
)

export default component.exports